// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDialog-VeloDialogContent_cls1__eko8O","cls2":"VeloDialog-VeloDialogContent_cls2__WQrhO VeloDialog-VeloDialogContent_cls1__eko8O"};